'use client';
import { useEffect, useState } from 'react';

import { UiLandingFooterBioderma } from '@/fo/ui/landing/footer/bioderma';
import { UiLandingHeaderBioderma } from '@/fo/ui/landing/header/bioderma';
import {
  Navigation,
  UiLandingNavigationBioderma
} from '@/fo/ui/landing/navigation/bioderma';
import { Product } from '@/fo/ui/landing/product-card/bioderma';

import { BuyNow } from '../components/BuyNow/BuyNow';
import { Efficiency } from '../components/Efficiency/Efficiency';
import { Formulas } from '../components/Formulas/Formulas';
import { HeroBanner } from '../components/HeroBanner/HeroBanner';
import { OtherProducts } from '../components/OtherProducts/OtherProducts';
import { Test } from '../components/Test/Test';

import { styles } from './FeatureLandingPageBiodermaHydrabio.styles';
import { HydrabioTestProduct } from './types';

export interface FeatureLandingPageBiodermaHydrabioProps {
  otherProducts: Product[];
  testProducts: HydrabioTestProduct[];
  navigation: Navigation[];
  bgFooter: {
    sm: string;
    md: string;
  };
  footnotes?: Array<{
    id: string;
    content: React.ReactNode;
  }>;
}

export function FeatureLandingPageBiodermaHydrabio({
  navigation,
  bgFooter,
  footnotes,
  otherProducts,
  testProducts
}: FeatureLandingPageBiodermaHydrabioProps) {
  const slots = styles();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isNearFooter, setIsNearFooter] = useState(false);

  useEffect(() => {
    let ticking = false;

    const handleScroll = () => {
      if (ticking) return;

      ticking = true;
      requestAnimationFrame(() => {
        const scrollY = window.scrollY;
        const windowHeight = window.innerHeight;
        const documentHeight = document.documentElement.scrollHeight;

        setIsScrolled(scrollY > 100);
        setIsNearFooter(scrollY + windowHeight > documentHeight - 200);
        ticking = false;
      });
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className={slots.base()}>
      <UiLandingHeaderBioderma progressColor="#00BBDC" />
      <div className="relative">
        <HeroBanner />
        <UiLandingNavigationBioderma
          className={slots.navigation({ isScrolled, isNearFooter })}
          items={navigation}
        />
      </div>
      <Formulas />
      <Efficiency />
      <Test products={testProducts} />
      <OtherProducts products={otherProducts} />
      <BuyNow isNearFooter={isNearFooter} />
      <UiLandingFooterBioderma
        footnotes={footnotes}
        bgFooter={bgFooter}
      />
    </div>
  );
}
